import axios from 'axios';

const API_BASE_URL = (process.env.VUE_APP_API_URL || 'http://127.0.0.1:8082/api/v1') + '/admin';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Request interceptor - add auth token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('getlokal_admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid - clear auth and redirect to login
      localStorage.removeItem('getlokal_admin_token');
      localStorage.removeItem('getlokal_admin_user');
      window.location.href = '/auth/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authApi = {
  login(email, password) {
    return api.post('/login', { email, password });
  },

  logout() {
    return api.post('/logout');
  },

  getProfile() {
    return api.get('/profile');
  }
};

// Export the configured axios instance for other API calls
export default api;
